export default "__VITE_ASSET__DZhTdLPD__"